import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as constants from '../constants/index';

const initialState = {
  userSettingsConfirmationModal: {
    isOpen: false,
  },
  imageDeleteConfirmationModal: {
    isOpen: false,
  },
  imageUploadLeavePageModal: {
    isOpen: false,
  },
};

const openImageDeleteConfirmationModal = (state) => update(state, {
  imageDeleteConfirmationModal: {
    isOpen: { $set: true },
  },
});

const closeImageDeleteConfirmationModal = (state) => update(state, {
  imageDeleteConfirmationModal: {
    isOpen: { $set: false },
  },
});

const openUserSettingsConfirmationModal = (state) => update(state, {
  userSettingsConfirmationModal: {
    isOpen: { $set: true },
  },
});

const closeUserSettingsConfirmationModal = (state) => update(state, {
  userSettingsConfirmationModal: {
    isOpen: { $set: false },
  },
});

const openImageUploadLeavePageModal = (state) => update(state, {
  imageUploadLeavePageModal: {
    isOpen: { $set: true },
  },
});

const closeImageUploadLeavePageModal = (state) => update(state, {
  imageUploadLeavePageModal: {
    isOpen: { $set: false },
  },
});

export default handleActions({
  [constants.OPEN_IMAGE_DELETE_CONFIRMATION_MODAL]: openImageDeleteConfirmationModal,
  [constants.CLOSE_IMAGE_DELETE_CONFIRMATION_MODAL]: closeImageDeleteConfirmationModal,

  [constants.OPEN_USER_SETTINGS_CONFIRMATION_MODAL]: openUserSettingsConfirmationModal,
  [constants.CLOSE_USER_SETTINGS_CONFIRMATION_MODAL]: closeUserSettingsConfirmationModal,

  [constants.OPEN_IMAGE_UPLOAD_LEAVE_PAGE_MODAL]: openImageUploadLeavePageModal,
  [constants.CLOSE_IMAGE_UPLOAD_LEAVE_PAGE_MODAL]: closeImageUploadLeavePageModal,
}, initialState);
